<ng-container *ngIf="isCustom; else: default">
  <mat-icon [color]="color" [svgIcon]="value" aria-hidden="true"></mat-icon>
</ng-container>

<ng-template #default>
  <mat-icon [fontSet]="fontSet" [color]="color" aria-hidden="true">{{ value }}</mat-icon>
</ng-template>
